import { ActionRegistry } from '~/hooks/actions/ActionRegistry.ts';
import {
  HIDE_POPUP_MENU_ACTION,
  SHOW_POPUP_MENU_ACTION,
  type HidePopupMenuOptions,
  type ShowPopupMenuOptions,
} from './types';

/**
 * Emits a Show Popup Menu request.
 * @param options - trigger and content of the menu
 */
export function dispatchShowPopupMenu(options: ShowPopupMenuOptions): void {
  ActionRegistry.getInstance().dispatch({
    type: SHOW_POPUP_MENU_ACTION,
    options,
  });
}

/**
 * Asks the Popup Menu Host to close whatever popup-menu surface is visible,
 * or only the one requested by a given owner.
 * @param options - optional owner the hide is limited to
 */
export function dispatchHidePopupMenu(options?: HidePopupMenuOptions): void {
  ActionRegistry.getInstance().dispatch({
    type: HIDE_POPUP_MENU_ACTION,
    options,
  });
}
